import React from 'react';
export const ExpertProfile = () => {
  return <section className="mb-12" data-id="element-134">
      <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-135">
        De expert achter de 90-minuten transformatie
      </h2>

      <div className="flex items-start mb-6" data-id="element-136">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/kJ5b6tBbH8hDNt52JG84mT/Scherm%C2%ADafbeelding_2025-08-15_om_15.44.02.png" alt="Amee de Bruijn" className="w-24 h-24 rounded-full object-cover mr-4 flex-shrink-0" data-id="element-137" />
        <div data-id="element-138">
          <p className="text-gray-800 leading-relaxed mb-3" data-id="element-139">
            Amee de Bruijn, gediplomeerd hondengedragsconsultant niveau 5, heeft
            het webinar ontwikkeld nadat ze zag hoe veel frustratie ontstaat
            door simpele misverstanden tussen honden en hun baasjes.
          </p>
        </div>
      </div>

      <div className="bg-teal-50 border-l-4 border-teal-600 p-5 mb-6 rounded-r-lg" data-id="element-140">
        <p className="text-gray-800 leading-relaxed italic" data-id="element-141">
          "Als je begrijpt dat je hond al die tijd probeerde met je te
          communiceren, verandert je hele relatie. En die verandering wil ik
          elke hondeneigenaar gunnen."
        </p>
      </div>

      <div className="bg-teal-50 border-l-4 border-teal-600 p-5 mb-6 rounded-r-lg" data-id="element-142">
        <p className="text-gray-800 leading-relaxed italic" data-id="element-143">
          "Mensen vragen me altijd waarom ik deze kennis gratis deel," zegt
          Amee. "Het antwoord is simpel: omdat het basisrecht zou moeten zijn om
          je hond te begrijpen."
        </p>
      </div>
    </section>;
};